import * as selectors from './selectors'

export const requestsSelectors = selectors
